import gql from 'graphql-tag';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { questionFieldsFragment } from './questionFieldsFragment';

export const scheduledSessionParticipantEntryOverrideFieldsFragment = gql`
  fragment AdminScheduledSessionParticipantEntryOverrideFields on ScheduledSessionParticipantEntryOverride {
    datetime
    overrideType
    evaluation { _ref }
    question { _ref }
    value {
      numericValue
      textValue
    }
    rQuestion { ...AdminQuestionFields }
    rEvaluation { ...AdminEvaluationFields }
  }

  ${questionFieldsFragment}
  ${evaluationFieldsFragment}
`;